import React from 'react'
import update from 'immutability-helper'

import { browserHistory } from 'react-router'

class Sliders extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            tab: 'lista-sliders'
        }
    }

    rederigir(e) {
        e.preventDefault()

        let id = e.target.id

        if (id === 'lista-sliders') {
            browserHistory.push('/sliders')
        } else if (id === 'nuevo-slider') {
            browserHistory.push('/sliders/nuevo-slider')
        }

        this.setState(update(this.state, {
            tab: { $set: id }
        }))
    }

    render() {
        let childs = this.props.children
            && React.cloneElement(this.props.children)

        return (
            <div className='config'>
                <ul className='nav justify-content-center'>
                    <li id='lista-sliders' className={this.state.tab === 'lista-sliders' ? 'nav-item active' : 'nav-item'} onClick={this.rederigir.bind(this)}>
                        <a id='lista-sliders' className='nav-link' onClick={this.rederigir.bind(this)}>TUS SLIDERS</a>
                    </li>
                    <li id='nuevo-slider' className={this.state.tab === 'nuevo-slider' ? 'nav-item active' : 'nav-item'} onClick={this.rederigir.bind(this)}>
                        <a id='nuevo-slider' className='nav-link' onClick={this.rederigir.bind(this)}>NUEVO SLIDER</a>
                    </li>
                </ul>
                {childs}
            </div>
        )
    }
}

export default Sliders